
/**
 * 알림 상태 정보
 */
export type NotificationResponseStatus = {
  /** 읽음 상태 */
  isRead: boolean;
};
